import api from "api";

export const fetchScholarshipPeers = (username: string, campaign: string) => api.get(`masterclass/scholarship-peers?username=${username}&campaign=${campaign}`);